import config from "@/config"
import http from "@/utils/request"

export default {
	list: {
		url: `${config.MAIN_URL}/user/api/monitoring`,
		name: '获取实时监视列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	eventStatus: {
		url: `${config.HNYJ_URL}/v1/admin/statistics/event/status`,
		name: '事件统计信息',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	resources: {
		url: `${config.HNYJ_URL}/v1/admin/statistics/resources`,
		name: '获取资源数据统计信息',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	eventTrend: {
		url: `${config.HNYJ_URL}/v1/admin/statistics/event/trend`,
		name: '获取事件趋势统计信息（柱状图）',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	disasterType: {
		url: `${config.HNYJ_URL}/v1/admin/statistics/event/disasterType`,
		name: '获取事件灾种类型统计信息（饼图）',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	responseLevel: {
		url: `${config.HNYJ_URL}/v1/admin/statistics/event/responseLevel`,
		name: '获取事件响应级别统计信息（饼图）',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	pubAdsbAddress: {
		url: `${config.ADSB_URL}/api/ridAdsb/current/day/address`,
		name: '获取实时监视列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	riduavAddress: {
		url: `${config.ADSB_URL}/api/ridUav/current/day/address`,
		name: '获取实时监视列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	list_co: {
		url: `${config.MAIN_URL}/user/api/v2/monitoring`,
		name: '根据企业获取实时监视列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	path: {
		url: `${config.MAIN_URL}/user/api/day/monitoring`,
		name: '获取历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	sbsPath: {
		url: `${config.ADSB_URL}/api/sbs/current/day/address`,
		name: '获取SBS历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	collect: {
		url: `${config.ADSB_URL}/api/sbs/collect/icao`,
		name: '收藏飞机',
		get: async function (paramOne, paramTwo) {
			return await http.get(this.url + '?companyId=' + paramOne + '&icao=' + paramTwo);
		},
	},
	cancelCollect: {
		url: `${config.ADSB_URL}/api/sbs/cancel/collect/icao`,
		name: '取消收藏飞机',
		get: async function (paramOne, paramTwo) {
			return await http.get(this.url + '?companyId=' + paramOne + '&icao=' + paramTwo);
		},
	},
	getCollect: {
		url: `${config.ADSB_URL}/api/sbs/collect/icaos`,
		name: '查询全部收藏的飞机',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	adsbPath: {
		url: `${config.ADSB_URL}/api/adsb/current/day/address`,
		name: '获取ADSB历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	efbPath: {
		url: `${config.ADSB_URL}/api/efb/current/day/address`,
		name: '获取efb历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	zhyPath: {
		url: `${config.ADSB_URL}/api/zhy/current/day/address`,
		name: '获取指挥仪历史轨迹',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	getZbStream: {
		url: `${config.ADSB_URL}/api/uav/getZbStream`,
		name: '获取直播地址',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getUavFlyUser: {
		url: `${config.ADSB_URL}/api/uav/getUavFlyUser`,
		name: '获取直播地址',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	getUavPlan: {
		url: `${config.MAIN_URL}/api/v1/hw/ykUavFlyPlan/newHistory`,
		name: '获取飞行计划',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	uavPath: {
		url: `${config.ADSB_URL}/api/uav/current/day/address`,
		name: '获取efb历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	efbiden: {
		url: `${config.ADSB_URL}/api/set/model/iden`,
		name: 'efb设置标识',
		put: async function (data = {}) {
			return await http.put(this.url, data);
		},
	},
	bdPath: {
		url: `${config.ADSB_URL}/api/bd/current/day/address`,
		name: '获取efb历史轨迹',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	alarms: {
		url: `${config.MAIN_URL}/api/v1/alarms`,
		name: '我的告警列表',
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	locaitons: {
		url: `${config.ADSB_URL}/api/clear/locaitons`,
		name: '清除航线',
		get: async function (data) {
			return await http.get(this.url, data);
		},
	},
	postalarm: {
		url: `${config.MAIN_URL}/api/v1/alarm`,
		name: '编辑告警',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	warningalarm: {
		url: `${config.MAIN_URL}/api/v1/trigger/alarm`,
		name: '告警',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	userBookmarksave: {
		url: `${config.MAIN_URL}/api/v1/userBookmark/save`,
		name: '保存书签',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	userBookmarklist: {
		url: `${config.MAIN_URL}/api/v1/userBookmark/data`,
		name: '书签列表',
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	userBookmarkdelete: {
		url: `${config.MAIN_URL}/api/v1/userBookmark/delete`,
		name: '删除书签',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

	getAirLineDetail: {
		url: `${config.MAIN_URL}/api/v1/airlineStatus/getAirLineDetail`,
		name: '获取航线状态',
		get: async function (data) {
			return await http.get(this.url + data);
		},
	},

}
